import { useNavigate, useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, Button } from '@klonup/design-system';

/**
 * `errorElement` para las rutas de `router.tsx`. React Router (data router)
 * gestiona los errores de render de cada ruta con su propio boundary interno
 * -- un `ErrorBoundary` de React normal envolviendo `<RouterProvider>` desde
 * fuera NUNCA lo captura -- así que cada ruta de nivel superior necesita este
 * elemento (los errores burbujean hacia el padre si una ruta no lo define).
 */
export default function RouteErrorFallback(): React.ReactElement {
  const error = useRouteError();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const message = error instanceof Error ? error.message : String(error);

  return (
    <div className="flex items-center justify-center" style={{ minHeight: '100vh' }}>
      <Card style={{ maxWidth: '480px', width: '100%', textAlign: 'center', padding: '2.5rem' }}>
        <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>⚠</div>
        <h2 className="text-xl font-bold text-klonup-indigo mb-2">{t('common.error_boundary.title')}</h2>
        <p style={{ fontSize: '0.875rem', color: '#6B7280', marginBottom: '1.5rem' }}>
          {t('common.error_boundary.route_description')}
        </p>
        {import.meta.env.DEV && (
          <pre
            style={{
              fontSize: '0.75rem',
              color: '#EF4444',
              backgroundColor: '#FEF2F2',
              padding: '0.75rem',
              borderRadius: '0.5rem',
              marginBottom: '1.5rem',
              overflowX: 'auto',
              textAlign: 'left',
              maxHeight: '120px',
            }}
          >
            {message}
          </pre>
        )}
        <Button variant="gradient" onClick={() => navigate('/')}>
          {t('common.error_boundary.back_home')}
        </Button>
      </Card>
    </div>
  );
}
